// ===============================
// side-effect modules (先に読む)
// ===============================
import "./ui/header.js";        // ヘッダー状態/スクロール挙動
import "./ui/nav.js";           // ハンバーガー
import "./ui/smooth-scroll.js"; // アンカーのスムーズスクロール
import "./ui/cookie-consent.js";// Cookie 同意（内部でDOMContentLoadedを持つ）
import "./libs/gtm.js";          // Cookie同意後にGTMを遅延読み込み

// ===============================
// utilities
// ===============================
const onReady = (fn) => {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn, { once: true });
};

// 複数回呼ばせないガード
let booted = false;
const boot = () => {
    if (booted) return;
    booted = true;

    // HTML側で .js をフラグに使えるように
    document.documentElement.classList.add("js");

    // 非クリティカル（BackToTopなど）は DOM 準備後に実行
    import("./ui/backtotop.js").then(({ initBackToTop }) => initBackToTop());
};

// ===============================
// boot
// ===============================
onReady(boot);
// ページ遷移API対応（bfcache など）
window.addEventListener("pageshow", boot, { once: true });
